// extracted by mini-css-extract-plugin
export default {"headergrid":"ResourceHeader_headergrid__Tedp6"};